import { render } from "./categoryTemplate.vue?vue&type=template&id=40b98d66&scoped=true"
import script from "./categoryTemplate.vue?vue&type=script&lang=js"
export * from "./categoryTemplate.vue?vue&type=script&lang=js"

import "./categoryTemplate.vue?vue&type=style&index=0&id=40b98d66&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b98d66"]])

export default __exports__